import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from './../../services/auth.service';
import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';
import { SpaceService } from './../../services/space.service';

@Component({
  selector: 'app-spaces',
  templateUrl: './spaces.component.html',
  styleUrls: ['./spaces.component.scss']
})
export class SpacesComponent implements OnInit {
  private subscribeData: Subscription;
  spaceId: any;
  accessToken: any;
  singleSpaceData: any;

  isEmptyDollHouse: any;

  loader = true;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.subscribeData = this.route.params.subscribe(params => {
      if (!params.id) {
        this.router.navigate(['/member']);
      }
      this.spaceId = params.id;
      this.getMemberSpaceDetails();
    });
  }

  getMemberSpaceDetails() {
    this.memberService.getMemberSpaceDetails({
      Authorization: this.accessToken,
      id: this.spaceId
    }).subscribe((response: any) => {
      this.singleSpaceData = response && response.data ? response.data : undefined;
      this.spaceService.setSpaceData(this.singleSpaceData);
      if (this.singleSpaceData.space_type === '3D') {
        this.validateSpaceObject();
      } else {
        this.isEmptyDollHouse = false;
        this.loader = false;
      }
    }, err => {
      this.router.navigate(['/member']);
    });
  }

  validateSpaceObject() {
    this.memberService.validateSpaceObject({
      Authorization: this.accessToken,
      id: this.spaceId
    }).subscribe(
      (res) => {
        this.isEmptyDollHouse = false;
        this.loader = false;
      },
      (err) => {
        if (err.error && err.error.errors && err.error.errors[0]) {
          this.spaceService.setSpaceErrorData(err.error.errors[0]);
        }
        this.isEmptyDollHouse = true;
        if (this.isEmptyDollHouse) {
          this.router.navigate([`/member/spaces/${this.spaceId}/empty-spaces`]);
        }
      }
    );
  }

  // <iframe src="http://localhost:4200/scenes/iframe/0f27d905-127b-4ff1-8a9a-acddfd7df41d" width="853" height="480" frameborder="0" allowfullscreen allowvr></iframe>


}
